export const config = {
  getTitleText: (count) => `Remove ${count > 1 ? `${count} Candidates` : 'Candidate'} from Shortlist`,
  titleIcon: 'delete',
  okText: 'Remove',
  okButtonDanger: true,
  width: 420,
  getBodyText: (count) =>
    count > 1
      ? `Are you sure you want to remove ${count} selected candidates from the shortlist?`
      : 'Are you sure you want to remove this candidate from the shortlist?',
  footerNote: 'The candidate will be moved back to the pipeline.',
  fields: [],
};
